(() => {
  if (window.__phGallerySwitcherReady) return;
  window.__phGallerySwitcherReady = true;

  const setActive = (buttons, selected) => {
    buttons.forEach(button => button.classList.toggle('active', button === selected));
  };

  document.addEventListener('click', event => {
    const adaptiveThumb = event.target.closest('[data-ph-adaptive-offer] [data-gallery-image]');
    if (adaptiveThumb) {
      event.preventDefault();
      const root = adaptiveThumb.closest('[data-ph-adaptive-offer]');
      const main = root?.querySelector('[data-gallery-main]');
      const counter = root?.querySelector('[data-gallery-counter]');
      const thumbs = [...(root?.querySelectorAll('[data-gallery-image]') || [])];
      if (!root || !main || !thumbs.length) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = adaptiveThumb.dataset.galleryImage;
      main.alt = adaptiveThumb.dataset.galleryAlt || '';
      setActive(thumbs, adaptiveThumb);
      if (counter) counter.textContent = `${thumbs.indexOf(adaptiveThumb) + 1} / ${thumbs.length}`;
      return;
    }

    const nineThumb = event.target.closest('[data-ph9-product] #gallery-thumbs button');
    if (!nineThumb) return;
    event.preventDefault();
    const root = nineThumb.closest('[data-ph9-product]');
    const main = root?.querySelector('#gallery-image');
    const counter = root?.querySelector('#gallery-counter');
    const thumbs = [...(root?.querySelectorAll('#gallery-thumbs button') || [])];
    if (!root || !main || !thumbs.length) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = nineThumb.dataset.image;
    main.alt = nineThumb.dataset.alt || '';
    setActive(thumbs, nineThumb);
    if (counter) counter.textContent = `${thumbs.indexOf(nineThumb) + 1} / ${thumbs.length}`;
  });
})();
